module.exports = __webpack_public_path__ + "static/media/expertise-redevelopment.73b882c7.jpg";